import { useState } from "react";
import SectionHeading from "./SectionHeading";
import { devices, qualityModes } from "@/mocks/shows";

export default function Quality() {
  const [activeId, setActiveId] = useState(qualityModes[1].id);
  const active = qualityModes.find((mode) => mode.id === activeId) ?? qualityModes[0];

  return (
    <section id="quality" className="scroll-mt-24 bg-background-100/60 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <SectionHeading
          eyebrow="高清观影"
          title="清晰度怎么选，大屏小屏都顺畅"
          description="高清观影不等于一直开最高档。网络、设备与观看场景不同，合适的档位也不同。点击下方档位可以查看它更适合的使用场景。"
        />

        <div className="mt-9 grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {qualityModes.map((mode) => {
            const isActive = mode.id === activeId;
            return (
              <button
                key={mode.id}
                type="button"
                onClick={() => setActiveId(mode.id)}
                aria-pressed={isActive}
                className={`reveal flex flex-col items-start rounded-lg border p-5 text-left transition-colors ${
                  isActive
                    ? "border-primary-400 bg-primary-50"
                    : "border-background-200 bg-background-50 hover:border-primary-300"
                }`}
              >
                <span
                  className={`flex h-11 w-11 items-center justify-center rounded-lg ${
                    isActive
                      ? "bg-primary-500 text-background-50"
                      : "bg-background-100 text-primary-600"
                  }`}
                >
                  <i className={`${mode.icon} text-xl`}></i>
                </span>
                <h3 className="mt-4 font-heading text-base font-bold text-foreground-950">
                  {mode.name}
                </h3>
                <p className="mt-0.5 text-xs font-medium text-primary-700">{mode.res}</p>
                <p className="mt-2 text-xs leading-6 text-foreground-500">{mode.desc}</p>
                <span
                  className={`mt-3 inline-flex items-center gap-1 text-xs font-medium ${
                    isActive ? "text-primary-700" : "text-foreground-400"
                  }`}
                >
                  <i className={isActive ? "ri-checkbox-circle-fill" : "ri-circle-line"}></i>
                  {isActive ? "当前选择" : "点击查看"}
                </span>
              </button>
            );
          })}
        </div>

        <div className="reveal mt-6 flex flex-col gap-3 rounded-lg border border-background-200 bg-background-50 p-5 sm:flex-row sm:items-center">
          <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-lg bg-accent-100 text-accent-700">
            <i className={`${active.icon} text-2xl`}></i>
          </span>
          <div>
            <p className="font-heading text-base font-bold text-foreground-950">
              当前档位：{active.name}（{active.res}）
            </p>
            <p className="mt-1 text-sm leading-7 text-foreground-600">
              {active.desc}。播放时若网速波动，播放器会先自动降档保证画面连续，网络恢复后再升回你选择的档位。
            </p>
          </div>
        </div>

        <div className="mt-12">
          <h3 className="reveal font-heading text-xl font-bold text-foreground-950">
            多端观看，进度跟随
          </h3>
          <p className="reveal mt-2 max-w-2xl text-sm leading-7 text-foreground-600">
            无论是在手机、电脑还是客厅大屏，观看进度与清晰度设置都会保留，换设备后可以接着上次的位置继续。
          </p>
          <div className="mt-6 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
            {devices.map((device) => (
              <article
                key={device.id}
                className="reveal flex items-start gap-3 rounded-lg border border-background-200 bg-background-50 p-5"
              >
                <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-lg bg-secondary-100 text-secondary-700">
                  <i className={`${device.icon} text-xl`}></i>
                </span>
                <div>
                  <h4 className="font-heading text-sm font-bold text-foreground-950">
                    {device.name}
                  </h4>
                  <p className="mt-1 text-xs leading-6 text-foreground-500">{device.desc}</p>
                </div>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}